export enum SubscriptionSecurity {
    none = '',
    https = 'https',
    httpsAndSecret = 'httpsAndSecret',
    secret = 'secret',
}